import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Model } from "../../models/model";
import "./reportes.css";
import "./homeReportes.css";

const reportGroups = [
  {
    title: "Financieros",
    icon: "bi-bar-chart-line",
    items: [
      {
        name: "Flujo de caja",
        route: "fcnew",
        purpose: "Anticipa tu saldo a partir de los ingresos y egresos proyectados.",
        question: "¿En qué períodos podría faltarnos caja para cubrir los pagos?",
      },
      {
        name: "Flujo de efectivo",
        route: "fenew",
        purpose: "Consulta las entradas, salidas y saldos de efectivo del período.",
        question: "¿Cuánto efectivo entró, cuánto salió y qué saldo quedó?",
      },
      {
        name: "Estado de resultados",
        route: "er",
        purpose: "Compara ventas por unidad de negocio, costos, gastos y utilidad.",
        question: "¿Qué vendimos, cuánto quedó y qué explica el cambio de utilidad?",
      },
    ],
  },
  {
    title: "Ventas",
    icon: "bi-graph-up-arrow",
    items: [
      {
        name: "Ventas por cliente",
        route: "ventas/pc",
        purpose: "Consulta cuánto aporta cada cliente a las ventas del período.",
        question: "¿Quiénes son nuestros principales clientes y cuánto dependemos de ellos?",
      },
      {
        name: "Ventas por unidad de negocio",
        route: "ventas/un",
        purpose: "Compara las ventas de las distintas líneas de proyectos o servicios.",
        question: "¿Qué unidad genera más ventas y cuál aporta menos?",
      },
      {
        name: "Histórico de ventas",
        route: "ventas/ph",
        purpose: "Revisa la evolución de las ventas entre períodos.",
        question: "¿Cuándo vendimos más y cómo han cambiado las ventas con el tiempo?",
      },
    ],
  },
  {
    title: "Clientes",
    icon: "bi-people",
    items: [
      {
        name: "Pendiente por cobrar",
        route: "ct",
        purpose: "Consulta los cobros pendientes y vencidos por cliente.",
        question: "¿Quién nos debe, cuánto está vencido y a quién debemos contactar primero?",
      },
    ],
  },
  {
    title: "Proveedores",
    icon: "bi-truck",
    items: [
      {
        name: "Pendiente por pagar",
        route: "st",
        purpose: "Revisa los compromisos de pago y los montos vencidos por proveedor.",
        question: "¿A quién debemos pagar y qué pagos requieren atención primero?",
      },
    ],
  },
];

export const HomeReportes = () => {
  useEffect(() => {
    Model.save({
      url: "logs",
      dataForm: {
        modulo: "reportes",
        accion: "ha ingresado a reportes",
        comentario: "success: ingreso okey",
      },
      showMessage: false,
    });
  }, []);

  return (
    <div className="p-container reports-home">
      <header className="reports-home-header">
        <h1 className="p-title">Reportes</h1>
        <p>Elige un reporte para revisar la rentabilidad, planificar la caja o priorizar cobros y pagos.</p>
      </header>

      {reportGroups.map(({ title, icon, items }) => (
        <section key={title} className="reports-home-group">
          <h2><i className={`bi ${icon}`} aria-hidden="true" />{title}</h2>
          <ul className="reports-home-grid">
            {items.map(({ name, route, purpose, question }) => (
              <li key={route} className="reports-home-card">
                <h3>
                  <Link to={`/reportes/${route}`}>
                    {name}<i className="bi bi-arrow-right" aria-hidden="true" />
                  </Link>
                </h3>
                <p>{purpose}</p>
                <div className="reports-home-question">
                  <strong>Pregunta que responde</strong>
                  <p>{question}</p>
                </div>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};
